module.exports = __webpack_public_path__ + "img/visu-ca-accompagne@2x.dd476301.png";